import { DateTime } from "luxon";

export class ManualLocationProduct{
    id!: string;
    name!: string;
    pickUp!: boolean;
    delivery!:boolean;
    day!: DateTime;
}